/*
 * Copyright (c) 2020 Staffino, s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Martin Komara, July 2020
 */

import React from 'react';
import ReactIframeResizer from 'iframe-resizer-react';
import { Box, styled, Theme } from '@staffino/primitive-controls';

type StyledLinkProps = {
  active?: boolean;
  theme?: Theme;
};

const StyledLink = styled.a<StyledLinkProps>((props) => ({
  cursor: 'pointer',
  color: props.active
    ? props.theme.colors.actionBackground
    : props.theme.colors.text,
  borderBottom: `4px solid ${
    props.active ? props.theme.colors.actionBackground : 'transparent'
  }`,
  display: 'inline-block',
  padding: '30px 15px 10px',
  minWidth: '150px',
  textAlign: 'center',
}));

const Iframe = styled(ReactIframeResizer)({
  border: 0,
  width: '100%',
  minWidth: '100%',
  flexGrow: 1,
});

type Props = {
  documents: Array<{ title: string; url: string }>;
  activeIndex: number;
  scrolling?: boolean;
  onChange?: (index: number) => void;
  onResized?: ReactIframeResizer.ResizerEvents['onResized'];
};
const DocumentViewer = React.forwardRef(
  (
    { documents, activeIndex, scrolling, onChange, onResized }: Props,
    ref: React.Ref<HTMLIFrameElement>,
  ) => (
    <>
      {documents.length > 1 && (
        <Box
          flexDirection={'row' as const}
          justifyContent="center"
          bg="white"
          key={documents[activeIndex].url}
        >
          {documents.map((document, index) => (
            <StyledLink
              active={index === activeIndex}
              onClick={() => onChange?.(index)}
              key={document.url}
            >
              {document.title}
            </StyledLink>
          ))}
        </Box>
      )}

      <Iframe
        ref={ref}
        title={documents[activeIndex].title}
        src={documents[activeIndex].url}
        onResized={onResized}
        scrolling={scrolling}
      />
    </>
  ),
);

export default DocumentViewer;
